import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-sidebar" }
const _hoisted_2 = {
  id: "js-primary-nav",
  class: "primary-nav",
  role: "navigation"
}
const _hoisted_3 = {
  id: "js-nav-menu",
  class: "nav-menu"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _cache[104] || (_cache[104] = _createElementVNode("div", { class: "page-logo" }, [
      _createElementVNode("img", {
        src: "img/logo.png",
        alt: "フュージョンアウトドアロゴ",
        "aria-roledescription": "logo"
      })
    ], -1)),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_ctx.showFlags.showDashboard_1)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/dashboard', $event)))
              }, _cache[66] || (_cache[66] = [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.blankpage"
                }, "ダッシュボード ", -1)
              ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showSales_2)
          ? (_openBlock(), _createElementBlock("li", {
              key: 1,
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[73] || (_cache[73] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "売上管理")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showProjectinput_100)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('/projectInput', $event)))
                      }, _cache[67] || (_cache[67] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "案件情報入力", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showProjectsearch_101)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('/projectSearch', $event)))
                      }, _cache[68] || (_cache[68] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "案件情報検索", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSalessearch_102)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTo('/salesSearch', $event)))
                      }, _cache[69] || (_cache[69] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "売上情報検索", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSuppliersearch_103)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goTo('/supplierSearch', $event)))
                      }, _cache[70] || (_cache[70] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "仕入情報検索", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSimulation_105)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goTo('/projectMigration', $event)))
                      }, _cache[71] || (_cache[71] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "シミュレーション", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showLock_104)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goTo('/dataLock', $event)))
                      }, _cache[72] || (_cache[72] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "データロック", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showReport_3)
          ? (_openBlock(), _createElementBlock("li", {
              key: 2,
              onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[81] || (_cache[81] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "帳票作成")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showInvsearch_200)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goTo('/invoiceSearch', $event)))
                      }, _cache[74] || (_cache[74] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "請求管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showDoclist_205)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.goTo('/doclist', $event)))
                      }, _cache[75] || (_cache[75] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "文書管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showAnnIndivperfsheet_201)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.goTo('/dashboard', $event)))
                      }, _cache[76] || (_cache[76] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "年次成績表（個人）", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showFinalABClist_202)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goTo('/finalABCList', $event)))
                      }, _cache[77] || (_cache[77] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "確定ＡＢＣリスト", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSalesforesolo_203)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goTo('/salesForecastNonConsolidated', $event)))
                      }, _cache[78] || (_cache[78] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "売上予想表（単独）", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSalescust_204)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goTo('/salesByCustomer', $event)))
                      }, _cache[79] || (_cache[79] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "取引先売上高", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showMatchingList_206)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 6,
                      onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.goTo('/matchingList', $event)))
                      }, _cache[80] || (_cache[80] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "照合リスト", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showDaily_4)
          ? (_openBlock(), _createElementBlock("li", {
              key: 3,
              onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[84] || (_cache[84] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "営業管理")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showDailyrepinput_300)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.goTo('/dailyReportEdit', $event)))
                      }, _cache[82] || (_cache[82] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "日報入力", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showDailyrepsearch_301)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.goTo('/dailyReportSearchIdeas', $event)))
                      }, _cache[83] || (_cache[83] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "日報検索", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showMaster_5)
          ? (_openBlock(), _createElementBlock("li", {
              key: 4,
              onClick: _cache[52] || (_cache[52] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[94] || (_cache[94] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "マスタ情報管理")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showSalesdestination_400)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.goTo('/salesDestinationList', $event)))
                      }, _cache[85] || (_cache[85] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "売上先マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSupplier_401)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.goTo('/supplierList', $event)))
                      }, _cache[86] || (_cache[86] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i19n": "nav.utilities_menu_child"
                        }, "仕入先マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showSponsor_407)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.goTo('/sponsorList', $event)))
                      }, _cache[87] || (_cache[87] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i19n": "nav.utilities_menu_child"
                        }, "広告主マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showEmployee_402)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 3,
                      onClick: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.goTo('/employeeList', $event)))
                      }, _cache[88] || (_cache[88] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i20n": "nav.utilities_menu_child"
                        }, "社員マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showBankaccount_403)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 4,
                      onClick: _cache[43] || (_cache[43] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.goTo('/bankAccountList', $event)))
                      }, _cache[89] || (_cache[89] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i21n": "nav.utilities_menu_child"
                        }, "口座マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showBBInfo_404)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 5,
                      onClick: _cache[45] || (_cache[45] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.goTo('/bulletinBoardInfomationList', $event)))
                      }, _cache[90] || (_cache[90] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i22n": "nav.utilities_menu_child"
                        }, "掲示板マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showBasegoal_405)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 6,
                      onClick: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.goTo('/baseGoalList', $event)))
                      }, _cache[91] || (_cache[91] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i23n": "nav.utilities_menu_child"
                        }, "拠点目標マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showPersonalgoal_406)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 7,
                      onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.goTo('/personalGoalList', $event)))
                      }, _cache[92] || (_cache[92] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i23n": "nav.utilities_menu_child"
                        }, "個人目標マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showHoliday_408)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 8,
                      onClick: _cache[51] || (_cache[51] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.goTo('/holidayList', $event)))
                      }, _cache[93] || (_cache[93] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i23n": "nav.utilities_menu_child"
                        }, "休日マスタ管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showRequest_6)
          ? (_openBlock(), _createElementBlock("li", {
              key: 5,
              onClick: _cache[55] || (_cache[55] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[96] || (_cache[96] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "申請書管理")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showRequestlist_500)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[54] || (_cache[54] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.goTo('/shinseisyolist', $event)))
                      }, _cache[95] || (_cache[95] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "申請書一覧", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showAttendance_7)
          ? (_openBlock(), _createElementBlock("li", {
              key: 6,
              onClick: _cache[60] || (_cache[60] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[99] || (_cache[99] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "勤怠管理")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showAttendancelist_600)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[57] || (_cache[57] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.goTo('/attendanceList', $event)))
                      }, _cache[97] || (_cache[97] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "勤怠管理", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showAttendanceedit_601)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[59] || (_cache[59] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.goTo('/attendanceEdit', $event)))
                      }, _cache[98] || (_cache[98] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "出勤表", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showFlags.showSpecial_8)
          ? (_openBlock(), _createElementBlock("li", {
              key: 7,
              onClick: _cache[65] || (_cache[65] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"])),
              class: "open"
            }, [
              _cache[102] || (_cache[102] = _createElementVNode("a", {
                href: "#",
                title: "Category",
                "data-filter-tags": "category"
              }, [
                _createElementVNode("span", {
                  class: "nav-link-text",
                  "data-i18n": "nav.category"
                }, "特殊操作")
              ], -1)),
              _createElementVNode("ul", null, [
                (_ctx.showFlags.showHistory_700)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[62] || (_cache[62] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.goTo('/operationHistoryList', $event)))
                      }, _cache[100] || (_cache[100] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "操作履歴", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFlags.showMknxtyrdata_701)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[64] || (_cache[64] = _withModifiers(($event: any) => (_ctx.selectMenu($event)), ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.goTo('/makeNextYearData', $event)))
                      }, _cache[101] || (_cache[101] = [
                        _createElementVNode("span", {
                          class: "nav-link-text",
                          "data-i18n": "nav.utilities_menu_child"
                        }, "来期見通しデータ作成", -1)
                      ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[103] || (_cache[103] = _createElementVNode("div", { class: "filter-message js-filter-message bg-success-600" }, null, -1))
    ])
  ]))
}